import styled from 'styled-components'

const Main = styled.div`
  flex: 1;
  background-color: #fafafa;
`

export default Main



// WEBPACK FOOTER //
// ./src/components/views/layout/Main.js